import { createAction, props } from '@ngrx/store';

const _ = log => `[Project] ${log}`;

export const fetchProducts = createAction(_('Fetch all products'));
export const productsFetched = createAction(_('Products fetched'), props<{ products: [] }>());
